export const MenuDotsIcon = () => {
  return (
    <svg fill="none" height="18" viewBox="0 0 4 18" width="4" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" fill="#0056B8" r="2" />
      <circle cx="2" cy="9" fill="#0056B8" r="2" />
      <circle cx="2" cy="16" fill="#0056B8" r="2" />
    </svg>
  );
};
